// A discussion occupies one position, dated by its actual latest comment. System
// notes occupy their own positions so they can appear between discussions.
const timestamp = (entry) => Date.parse(entry?.created_at) || 0;
const compareEntries = (a, b) => timestamp(a) - timestamp(b) || a.id.localeCompare(b.id);

export const commentGroupDate = (group) => Math.max(Date.parse(group.page?.scope?.latest_comment_at) || 0, ...group.entries.map(timestamp));

export const buildCommentTimeline = (groups, { activitiesOnly = false, inlineScopeKey = null, descending = false } = {}) => {
  const items = [];
  const seenActivities = new Set();
  groups.forEach((group) => {
    (group.page?.entries || []).filter((entry) => entry.kind === 'system_note').forEach((entry) => {
      // A shared source can expose the same activity through several scopes.
      if (seenActivities.has(entry.id)) return;
      seenActivities.add(entry.id);
      items.push({ type: 'activity', key: `activity:${entry.id}`, date: timestamp(entry), entry, scope: group.scope });
    });
    if (!activitiesOnly && (group.entries.length || group.page?.next_cursor || group.key === inlineScopeKey)) {
      const ordered = { ...group, entries: [...group.entries].sort((a, b) => (descending ? -1 : 1) * compareEntries(a, b)) };
      items.push({ type: 'discussion', key: `discussion:${group.key}`, date: commentGroupDate(ordered), group: ordered });
    }
  });
  return items.sort((a, b) => (descending ? -1 : 1) * (a.date - b.date || a.key.localeCompare(b.key)));
};
